import React from "react";
import styled from "styled-components";

import Section from "../basic/layouts/Section";
import Text from "../basic/Text";
import Button from "../basic/Button";
import HTMLWrapper from "../basic/HTMLWrapper";
import getTextInElement from "../basic/helper-functions/getTextInElement";
import Link from "../util/link";
import { Overline } from "../basic/layouts/Section";
import { Grid, Cell } from "../basic/layouts/Grid";
import theme from "../../styles/theme";

const {
	colors,
	font,
	breakPoints: { screenQuery },
} = theme;

const LinkItem = styled(Cell)`
	text-align: left;

	img {
		height: ${(props) => (props.iconHeight ? props.iconHeight : "auto")};
		width: auto
		padding: 0;
		margin-bottom: 20px;
	}

	a {
		> div {
			padding: 10px;
			margin: 10px;
		}
	}

	box-shadow: none;
	transition: all 0.75s ease;

	:hover {
		box-shadow: 0px 8px 48px rgba(46, 64, 100, 0.15);
		background-color: ${colors.white};
	}
`;
const Item = styled(Cell)`
	text-align: center;
	img {
		height: 115px;
		padding: 15px;
	}

	margin: ${(props) =>
		props.index === 0
			? `0 40px 0 0`
			: props.index === 1
			? `0 20px`
			: props.index === 2
			? `0 0 0 40px`
			: "0"};
	${screenQuery.large} {
		margin: 0;
	}
`;

const IconGrid = styled(Grid)`
	h2 {
		width: 100%;
	}
`;

const BottomButton = styled(Button)`
	display: block;
	max-width: 200px;
	margin: 0 auto;
	margin-top: 75px;
`;

const IconsWrapper = styled(HTMLWrapper)`
	h5 {
		font-family: ${font.semiBold};
		font-size: 20px;
		line-height: 24px;
		letter-spacing: 0.02em;
		color: ${colors.newBrand.black};
	}

	p,
	p:not([class^="Body"]):not([class^="AllCaps"]) {
		color: ${colors.newBrand.lightGrey};
	}
`;

const IconsA = ({
	header,
	subheader,
	overline,
	icon1Description,
	icon2Description,
	icon3Description,
	link1,
	link2,
	link3,
	icon1,
	icon2,
	icon3,
	className,
	background,
	bottomButtonUrl,
	bottomButton,
	iconHeight,
}) => {
	const items = [
		{
			text: icon1Description,
			icon: icon1,
			link: link1,
		},
		{
			text: icon2Description,
			icon: icon2,
			link: link2,
		},
		{
			...(icon3Description && { text: icon3Description }),
			...(icon3 && { icon: icon3 }),
			...(link3 && { link: link3 }),
		},
	].filter((value) => Object.keys(value).length !== 0);

	return (
		<Section className={`icons-a ${className}`} backgroundColor={background}>
			{overline && (
				<Overline className="overline" style={{ textAlign: "center" }}>
					{overline}
				</Overline>
			)}
			<IconGrid className="icons-grid" header={header} subheader={getTextInElement(subheader, "p")}>
				{items.map((item, index) =>
					item?.link ? (
						<LinkItem
							index={index}
							span={4}
							spanMd={4}
							inlineMd
							spanSm={12}
							startSm={1}
							key={item.text}
							className="icons-wrapper"
							iconHeight={iconHeight}
						>
							<Link to={item.link}>
								<div>
									<img className="icon" src={item.icon} />
									<IconsWrapper
										replaceNode={{ h2: "h5", h3: "h5", p: "b4" }}
										html={item.text}
										className="subheader"
									/>
								</div>
							</Link>
						</LinkItem>
					) : (
						<Item
							index={index}
							span={4}
							spanMd={4}
							inlineMd
							spanSm={12}
							startSm={1}
							key={item.text}
							className="icons-wrapper"
						>
							<img className="icon" src={item.icon} />
							<HTMLWrapper
								replaceNode={{ h2: "h5", h3: "h5", p: "b4" }}
								html={item.text}
								className="subheader"
							/>
						</Item>
					)
				)}
			</IconGrid>
			{bottomButton && <BottomButton link={bottomButtonUrl}>{bottomButton}</BottomButton>}
		</Section>
	);
};

export default IconsA;

export const GiveCardIcons = styled(IconsA)`
	.grid-container {
		grid-gap 0;
	}

    .header-cell {
        margin-bottom: 30px;
    }

    .icons-grid {
        grid-gap: 25px;
    }
    .icons-wrapper {
        text-align: left;
        background: rgba(128, 41, 98, 0.08);
        padding: 64px 38px;
        margin: 0;
        border-radius: 24px;

        h5 {
            font-size: 20px;
        }
        p {
            font-size: 17px;
            line-height: 26px;
        }
    }
    .icon {
        background-color: #8C3D71;
        width: 48px;
        height: 48px;
        border-radius: 8px;
        margin-bottom: 16px;
        padding: 12px;
    }
`;